export default __webpack_public_path__ + "static/media/video.6f0551a9.svg";